import { JsonTreeCard } from '@/components/ui/json-tree';
import { DetailList } from '@/features/user-console/components/detail-list';
import { parseJsonIfString } from '@/utils/json';
import { formatAnswerValue, humanizeAnswerKey, isFlatRecord } from './answer-format';

/** Flat answer objects read as a label/value list; anything nested keeps the collapsible JSON tree. */
export const StructuredAnswers = ({ value }: { value: unknown }) => {
  const parsed = parseJsonIfString(value);
  if (isFlatRecord(parsed)) {
    return (
      <DetailList
        items={Object.entries(parsed).map(([key, entry]) => ({
          key,
          label: <span title={key}>{humanizeAnswerKey(key)}</span>,
          value: formatAnswerValue(entry),
        }))}
      />
    );
  }
  return <JsonTreeCard data={parsed} />;
};
StructuredAnswers.displayName = 'StructuredAnswers';
